<ng-container *ngIf="videoUnlocked$ | async; else videoPlaceholder">
  <div [innerHTML]="videoIframeHtml"></div>
</ng-container>
<ng-template #videoPlaceholder>
  <div
    class="video-thumbnail"
    (click)="videoUnlocked$.next(true)"
    (keyup.enter)="videoUnlocked$.next(true)"
    tabindex="0"
    [style.height.px]="height"
    [style.width.px]="width"
  >
    <img [src]="imageUrl" />
    <div class="play-button-wrapper">
      <div class="play-button"></div>
    </div>
  </div>
</ng-template>
